import * as React from "react";
import { observer } from "mobx-react-lite";
import { TranslationContext, useTranslation } from "src/hooks";
import {
  FilePickerContainer,
  IFilePickerContainerProps,
} from "./components/Container.component";
import { FilePickerContext, FilePickerState } from "../states";

export type IFilePickerWithCameraProps = {
  helperText?: string;
  isLoading?: boolean;
  isError?: boolean;
  onChange?: (files: File) => void;
  previewUrl?: string;
  maxSize?: number; // in megabyte, default is 10MB
  onDelete?: () => void;
  tempFile?: File;
  onClick?: () => void;
  onError?: (errors: Error) => void;
} & IFilePickerContainerProps;

const ACCEPTED_TYPES = ["image/jpg", "image/jpeg", "image/png"];

export const ImageFilePickerWithCamera: React.FC<IFilePickerWithCameraProps> = observer(
  (props) => {
    const {
      onChange,
      onDelete,
      tempFile,
      onClick,
      onError,
      getErrorTranslation,
      guideProps,
      contentProps,
      ...other
    } = props;

    const translate = useTranslation(require("../translations.json"));

    const [temporaryFile, setTemporaryFile] = React.useState<File | undefined>(
      tempFile!
    );
    const inputRef = React.useRef<HTMLInputElement>(null);

    const _onChange = (file: File) => {
      setTemporaryFile(file);
      onChange?.(file);
    };

    const _onDelete = () => {
      setTemporaryFile(undefined);
      // @ts-ignore
      inputRef.current.value = "";
      onDelete?.();
    };

    const state = new FilePickerState(
      {
        temporaryFile: temporaryFile,
        ...other,
        acceptedTypes: ACCEPTED_TYPES,
      },
      _onChange,
      undefined,
      translate,
      inputRef,
      _onDelete,
      onClick,
      onError
    );

    return (
      <TranslationContext.Provider value={require("../translations.json")}>
        <FilePickerContext.Provider value={state}>
          <FilePickerContainer
            getErrorTranslation={getErrorTranslation}
            guideProps={guideProps}
            contentProps={contentProps}
          />
        </FilePickerContext.Provider>
      </TranslationContext.Provider>
    );
  }
);
